import React from "react";

interface AnnouncementModalProps {
  onClose: () => void;
}

const AnnouncementModal: React.FC<AnnouncementModalProps> = ({ onClose }) => {
  const handbookUrl = process.env.REACT_APP_HANDBOOK_URL;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="announcement-title"
        className="max-h-[90vh] w-full max-w-2xl overflow-y-auto rounded-lg bg-white p-6 shadow-xl"
      >
        <h2
          id="announcement-title"
          className="mb-5 text-2xl font-bold text-gray-900"
        >
          INFORMASI
        </h2>

        <div className="space-y-4 text-left text-sm leading-6 text-gray-700">
          <p>Dear Customer,</p>
          <p>
            Untuk memberikan layanan yang lebih baik, kami akan melakukan
            pembaruan pada MAXCODE.
          </p>
          <div>
            <p>Adapun hal yang akan diperbarui adalah:</p>
            <ul className="list-disc space-y-1 pl-5">
              <li>Penambahan pencarian item berdasarkan kategori penjualan</li>
              <li>Generate barcode berdasarkan serial number</li>
              <li>Posting serial number ke Accurate Online</li>
            </ul>
          </div>
          {handbookUrl && (
            <p>
              Handbook dapat diakses pada link berikut:{" "}
              <a
                href={handbookUrl}
                target="_blank"
                rel="noreferrer"
                className="text-blue-600 underline hover:text-blue-800"
              >
                Handbook
              </a>
              .
            </p>
          )}
          <p>
            Jika Anda memiliki pertanyaan, jangan ragu untuk menghubungi tim support pelanggan kami. Terima kasih atas pengertian Anda!
          </p>
          <p>
            Best regards,
            <br />
            MAXCODE Team
          </p>
        </div>

        <div className="mt-6 flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="rounded-md bg-blue-500 px-5 py-2 text-sm font-medium text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            Oke
          </button>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementModal;
